import { Box, Button, Container, Divider, Grid2 as Grid, Link, Typography } from "@mui/material"
import SectionSkeleton from "../../../../components/ui/SectionSkeleton"
import SkeletonImage from "../../../../components/ui/SkeletonImage"
import Imagess from "../../../../assets/js/Images"
import { Link as NavLink } from "react-router-dom"
import Images from "../../../../assets/js/Images"
import { Fragment, lazy, Suspense } from "react"
import { data1 } from "./data"

const TopBannerA = lazy(() => import("../../../../components/common/TopBannerA"))
const CtaSection = lazy(() => import("../../../../components/ui/CtaSection"))
const Specialist = lazy(() => import("./Specialist"))
const Support = lazy(() => import("./Support"))

function Mission() {
  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerA
          overlay={false}
          heading="Our Mission"
          currentPage="Our Mission"
          bannerImg={Imagess?.aboutNew}
        />
      </Suspense>

      <Box component="section" sx={{ py: { xs: 10, lg: 8 } }}>
        <Container maxWidth={false} fixed>
          <Box>
            <Typography
              color="other.color1"
              variant="displayLarge"
            >About Us
            </Typography>
            <Divider
              sx={{
                mt: 2,
                mx: "auto",
                maxWidth: "200px",
                borderWidth: "1.5px",
                borderColor: "secondary.main",
              }}
            />
            <Typography
              mt={2}
              mx="auto"
              fontSize={32}
              maxWidth={1100}
              variant="displayLarge"
              color="secondary.main"
            >"Calm mind brings inner strength and self-confidence, so that's very important for good health."
            </Typography>
            <Typography
              mt={2}
              fontSize={20}
              fontWeight="700"
              textAlign="center"
              color="other.color2"
              variant="displayNormal"
              component="p"
            >His Holiness, the 14th Dalai Lama
            </Typography>
          </Box>
          <Grid container spacing={4} mt={5}>
            {data1?.map((item, i) => (
              <Grid key={i} size={{ xs: 12, md: 6, lg: 4 }}>
                <Box
                  sx={{
                    gap: 2.5,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <SkeletonImage
                    sx={{
                      mx: "auto",
                      width: "40px",
                      height:"50ox",
                      objectFit: "contain",
                    }}
                    src={item?.image}
                  />
                  <Typography
                    fontSize={50}
                    color="#388080"
                    variant="displayLarge"
                  >{item?.count}
                  </Typography>
                  <Typography
                    fontSize={20}
                    fontWeight="700"
                    textAlign="center"
                    color="other.color1"
                  >{item?.title}
                  </Typography>
                  <Typography
                    textAlign="center"
                    color="other.color2"
                    variant="bodyNormal"
                  >{item?.subtitle}
                  </Typography>
                </Box>
              </Grid>
            ))
            }
          </Grid>
        </Container>
      </Box>

      <Box
        sx={{
          py: { xs: 10, md: 15, lg: 20 },
          backgroundImage: `url(${Images?.mission1})`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
        component="section"
      >
        <Container maxWidth={false} fixed>
          <Grid container>
            <Grid size={{ xs: 12, md: 6, lg: 8 }}>
            </Grid>
            <Grid size={{ xs: 12, md: 6, lg: 4 }}>
              <Box
                sx={{
                  p: 4,
                  bgcolor: "white",
                }}
              >
                <Typography
                  variant="displayLarge"
                  color="other.color1"
                >Our Story.
                </Typography>
                <Typography
                  mt={3}
                  textAlign="center"
                  color="other.color2"
                >We got to know that every year, one in four of us will experience a mental health problem. But hundreds of thousands of people are still struggling.
                </Typography>
                <Typography
                  mt={2}
                  textAlign="center"
                  color="other.color2"
                >As we believe no one should have to face a depression, loneliness or emotional problems alone.
                </Typography>
                <Typography
                  mt={3}
                  fontSize={18}
                  fontWeight="700"
                  textAlign="center"
                  color="secondary.dark"
                >Our effort is to give you support, and fight your corner.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Suspense fallback={<SectionSkeleton />}>
        <Specialist />
      </Suspense>

      <Box
        sx={{ py: 5, bgcolor: "secondary.dark" }}
        component="section"
      >
        <Container maxWidth={false} fixed>
          <Box mx="auto" color="white" textAlign="center">
            <Typography
              fontSize={18}
            >
              <Typography
                fontSize={20}
                component="span"
                fontWeight="700"
                color="other.color1"
              >We're here for you.
              </Typography> Mail us at&nbsp;
              <Link
                sx={{
                  color: "white",
                  textDecorationColor: "white",
                }}
                underline="hover"
                component={NavLink}
                to="mailto:support@innerpal.com"
              >support@innerpal.com
              </Link> or&nbsp;
              <Link
                sx={{
                  color: "white",
                  textDecorationColor: "white",
                }}
                underline="hover"
                component={NavLink}
              >request an appointment online.
              </Link>
            </Typography>
          </Box>
        </Container>
      </Box>

      <Suspense fallback={<SectionSkeleton />}>
        <Support />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <CtaSection>
          <Typography
            variant="ctaNormal"
          >Join Us & Begin Your Journey
          </Typography>
          <Button
            variant="CtaButton"
          >Join Now
          </Button>
        </CtaSection>
      </Suspense>
    </Fragment>
  )
}

export default Mission